
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.333 10.833a7.75 7.75 0 00-7.75 7.75v25.834a7.75 7.75 0 007.75 7.75h41.334a7.75 7.75 0 007.75-7.75V18.583a7.75 7.75 0 00-7.75-7.75H10.333zm-2.583 8.44v25.144A2.583 2.583 0 0010.333 47h41.334a2.583 2.583 0 002.583-2.583V19.273L35.758 33.656a7.75 7.75 0 01-9.516 0L7.75 19.273zM50.042 16H11.958l17.456 13.577c.933.726 2.24.726 3.172 0L50.042 16z","fill":"#313131"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h62v62H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      